import { apiService } from '../../../services/api';
import type { UserFileItem } from '../../../types/api';
import { getReportDownload } from '../../reports/lib/downloadReport';
import { isSafeApiDownloadUrl } from './downloadUrl';

export async function getUserFileDownloadUrl(
  file: UserFileItem,
): Promise<string> {
  if (!file.download_available) {
    throw new Error('Este archivo no está disponible para descargar.');
  }

  if (file.kind === 'report') {
    const response = await getReportDownload(file.id);
    return response.downloadUrl;
  }

  const response =
    file.kind === 'compliance'
      ? await apiService.downloadComplianceDocument(file.id)
      : file.kind === 'invoice'
        ? await apiService.downloadInvoiceFile(file.id)
        : await apiService.downloadSmartSortingFile(file.id);

  if (!isSafeApiDownloadUrl(response.presigned_get_url)) {
    throw new Error('El enlace de descarga no es seguro.');
  }

  return response.presigned_get_url;
}
